import { useParams } from "react-router-dom";
import { LauraAuditView } from "@/app/components/laura/LauraAuditView";

export default function ProjectLauraAuditPage() {
    const { id, auditId } = useParams<{ id: string; auditId: string }>();
    if (!id || !auditId) return null;
    return <LauraAuditView auditId={auditId} projectId={id} />;
}
